import createFieldArray from './createFieldArray';
import plain from './structure/plain';
export default createFieldArray(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/FieldArray.js
// module id = 2091
// module chunks = 1